const genUnits = (baseName, baseSymbol, variants) => {
  const units = [{ id: baseSymbol, name: baseName, factor: 1 }];
  variants.forEach(v => {
    units.push({ id: v.sym, name: v.name, factor: v.factor });
  });
  return units;
};

export const categories = [
  {
    id: 'common',
    name: 'Conversores Comuns',
    converters: [
      {
        id: 'length', name: 'Comprimento', description: 'Converta unidades de comprimento como metros, quilômetros, milhas, etc.', isTemperature: false,
        units: [
          { id: 'm', name: 'Metro', factor: 1 },
          { id: 'km', name: 'Quilômetro', factor: 1000 },
          { id: 'cm', name: 'Centímetro', factor: 0.01 },
          { id: 'mm', name: 'Milímetro', factor: 0.001 },
          { id: 'mi', name: 'Milha', factor: 1609.344 },
          { id: 'yd', name: 'Jarda', factor: 0.9144 },
          { id: 'ft', name: 'Pé', factor: 0.3048 },
          { id: 'in', name: 'Polegada', factor: 0.0254 },
          { id: 'legua', name: 'Légua', factor: 6600 },
          { id: 'braca', name: 'Braça', factor: 2.2 },
          { id: 'vara', name: 'Vara', factor: 1.1 }
        ]
      },
      {
        id: 'temperature', name: 'Temperatura', description: 'Converta entre Celsius, Fahrenheit e Kelvin.', isTemperature: true,
        units: [
          { id: 'c', name: 'Celsius', symbol: '°C' },
          { id: 'f', name: 'Fahrenheit', symbol: '°F' },
          { id: 'k', name: 'Kelvin', symbol: 'K' }
        ]
      },
      {
        id: 'weight', name: 'Peso e Massa', description: 'Converta unidades de peso e massa.', isTemperature: false,
        units: [
          { id: 'kg', name: 'Quilograma', factor: 1 },
          { id: 'g', name: 'Grama', factor: 0.001 },
          { id: 'mg', name: 'Miligrama', factor: 0.000001 },
          { id: 't', name: 'Tonelada Métrica', factor: 1000 },
          { id: 'lb', name: 'Libra', factor: 0.453592 },
          { id: 'oz', name: 'Onça', factor: 0.0283495 },
          { id: 'arroba', name: 'Arroba', factor: 15 }
        ]
      },
      {
        id: 'volume', name: 'Volume', description: 'Converta unidades de volume e capacidade.', isTemperature: false,
        units: [
          { id: 'l', name: 'Litro', factor: 1 },
          { id: 'ml', name: 'Mililitro', factor: 0.001 },
          { id: 'm3', name: 'Metro Cúbico', factor: 1000 },
          { id: 'gal', name: 'Galão Americano', factor: 3.78541 }
        ]
      },
      {
        id: 'area', name: 'Área', description: 'Converta unidades de área de superfície.', isTemperature: false,
        units: [
          { id: 'm2', name: 'Metro Quadrado', factor: 1 },
          { id: 'km2', name: 'Quilômetro Quadrado', factor: 1000000 },
          { id: 'ha', name: 'Hectare', factor: 10000 },
          { id: 'ac', name: 'Acre', factor: 4046.86 },
          { id: 'alqueire-sp', name: 'Alqueire Paulista', factor: 24200 }
        ]
      },
      {
        id: 'time', name: 'Tempo', description: 'Converta unidades de tempo.', isTemperature: false,
        units: [
          { id: 's', name: 'Segundo', factor: 1 },
          { id: 'min', name: 'Minuto', factor: 60 },
          { id: 'h', name: 'Hora', factor: 3600 },
          { id: 'd', name: 'Dia', factor: 86400 }
        ]
      },
      {
        id: 'speed', name: 'Velocidade', description: 'Converta unidades de velocidade.', isTemperature: false,
        units: [
          { id: 'm/s', name: 'Metros por segundo', factor: 1 },
          { id: 'km/h', name: 'Quilômetros por hora', factor: 0.277778 },
          { id: 'mph', name: 'Milhas por hora', factor: 0.44704 },
          { id: 'knots', name: 'Nós', factor: 0.514444 }
        ]
      },
      {
        id: 'tamanho-camiseta',
        name: 'Tamanho de Camiseta',
        description: 'Converta tamanhos de camiseta entre Brasil, EUA e Europa (letras).',
        isTemperature: false,
        units: [
          { id: 'br', name: 'Brasil (BR)', symbol: 'BR', factor: 1 },
          { id: 'us', name: 'Estados Unidos (US)', symbol: 'US', factor: 1 },
          { id: 'eu', name: 'Europa (EU)', symbol: 'EU', factor: 1 }
        ],
        sizeOptions: {
          br: ['PP', 'P', 'M', 'G', 'GG', 'XGG'],
          us: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
          eu: ['XS', 'S', 'M', 'L', 'XL', 'XXL']
        },
        customConvert: (value, fromUnit, toUnit) => {
          // Tabela de letras (ordem crescente)
          // Índice: 0=PP/XS, 1=P/S, 2=M, 3=G/L, 4=GG/XL, 5=XGG/XXL
          const brSizes = ['PP', 'P', 'M', 'G', 'GG', 'XGG'];
          const usSizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
          const euSizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

          const normalize = (v) => String(v).toUpperCase().trim();
          let idx = -1;

          if (fromUnit === 'br') idx = brSizes.indexOf(normalize(value));
          else if (fromUnit === 'us') idx = usSizes.indexOf(normalize(value));
          else if (fromUnit === 'eu') idx = euSizes.indexOf(normalize(value));

          if (idx === -1) return value; // valor não reconhecido

          if (toUnit === 'br') return brSizes[idx];
          if (toUnit === 'us') return usSizes[idx];
          if (toUnit === 'eu') return euSizes[idx];
          return value;
        }
      },
      {
        id: 'tamanho-calca',
        name: 'Tamanho de Calça',
        description: 'Converta tamanhos de calça entre Brasil, EUA e Europa (letras).',
        isTemperature: false,
        units: [
          { id: 'br', name: 'Brasil (BR)', symbol: 'BR', factor: 1 },
          { id: 'us', name: 'Estados Unidos (US)', symbol: 'US', factor: 1 },
          { id: 'eu', name: 'Europa (EU)', symbol: 'EU', factor: 1 }
        ],
        sizeOptions: {
          br: ['PP', 'P', 'M', 'G', 'GG', 'XGG'],
          us: ['XS', 'S', 'M', 'L', 'XL', 'XXL'],
          eu: ['XS', 'S', 'M', 'L', 'XL', 'XXL']
        },
        customConvert: (value, fromUnit, toUnit) => {
          // Mesma escala de letras usada em calças casuais (PP→XGG)
          const brSizes = ['PP', 'P', 'M', 'G', 'GG', 'XGG'];
          const usSizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
          const euSizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

          const normalize = (v) => String(v).toUpperCase().trim();
          let idx = -1;

          if (fromUnit === 'br') idx = brSizes.indexOf(normalize(value));
          else if (fromUnit === 'us') idx = usSizes.indexOf(normalize(value));
          else if (fromUnit === 'eu') idx = euSizes.indexOf(normalize(value));

          if (idx === -1) return value;

          if (toUnit === 'br') return brSizes[idx];
          if (toUnit === 'us') return usSizes[idx];
          if (toUnit === 'eu') return euSizes[idx];
          return value;
        }
      },
      {
        id: 'tamanho-tenis',
        name: 'Tamanho de Tênis',
        description: 'Converta tamanhos de tênis entre Brasil, EUA, Europa, Reino Unido e Japão.',
        isTemperature: false,
        units: [
          { id: 'br', name: 'Brasil (BR)', symbol: 'BR', factor: 1 },
          { id: 'us', name: 'Estados Unidos (US)', symbol: 'US', factor: 1 },
          { id: 'eu', name: 'Europa (EU)', symbol: 'EU', factor: 1 },
          { id: 'uk', name: 'Reino Unido (UK)', symbol: 'UK', factor: 1 },
          { id: 'jp', name: 'Japão (JP)', symbol: 'JP', factor: 1 }
        ],
        sizeOptions: {
          br: ['33','34','35','36','37','38','39','40','41','42','43','44','45','46','47','48'],
          us: ['4.5','5','5.5','6','6.5','7','7.5','8','8.5','9','9.5','10','10.5','11','11.5','12','12.5','13','13.5','14','14.5','15'],
          eu: ['35','36','37','38','39','40','41','42','43','44','45','46','47','48','49','50'],
          uk: ['3','3.5','4','4.5','5','5.5','6','6.5','7','7.5','8','8.5','9','9.5','10','10.5','11','11.5','12','12.5','13','13.5','14'],
          jp: ['21.5','22','22.5','23','23.5','24','24.5','25','25.5','26','26.5','27','27.5','28','28.5','29','29.5','30','30.5','31','31.5','32']
        },
        customConvert: (value, fromUnit, toUnit) => {
          const table = [
            [33, 4.5, 35, 3.0, 21.5],
            [34, 5.5, 36, 4.0, 22.5],
            [35, 6.0, 37, 4.5, 23.0],
            [36, 7.0, 38, 5.5, 24.0],
            [37, 7.5, 39, 6.0, 25.0],
            [38, 8.5, 40, 7.0, 25.5],
            [39, 9.0, 41, 7.5, 26.0],
            [40, 9.5, 42, 8.0, 26.5],
            [41, 10.0, 43, 9.0, 27.5],
            [42, 10.5, 44, 9.5, 28.0],
            [43, 11.5, 45, 10.5, 29.0],
            [44, 12.0, 46, 11.0, 30.0],
            [45, 12.5, 47, 12.0, 30.5],
            [46, 13.5, 48, 13.0, 31.5],
            [47, 14.0, 49, 13.5, 32.0],
            [48, 15.0, 50, 14.5, 32.5]
          ];

          const col = { br: 0, us: 1, eu: 2, uk: 3, jp: 4 };
          const fromCol = col[fromUnit];
          const toCol = col[toUnit];
          if (fromCol === undefined || toCol === undefined) return value;

          const num = parseFloat(value);
          if (isNaN(num)) return value;

          let bestIdx = 0;
          let bestDiff = Math.abs(table[0][fromCol] - num);
          for (let i = 1; i < table.length; i++) {
            const diff = Math.abs(table[i][fromCol] - num);
            if (diff < bestDiff) {
              bestDiff = diff;
              bestIdx = i;
            }
          }

          const result = table[bestIdx][toCol];
          return Number.isInteger(result) ? result : result;
        }
      },
      {
        id: 'consumo-combustivel',
        name: 'Consumo de Combustível',
        description: 'Converta consumo de combustível entre km/l, L/100km, mpg (EUA) e mpg (Reino Unido).',
        isTemperature: false,
        units: [
          { id: 'km/l', name: 'Quilômetro por Litro', symbol: 'km/l' },
          { id: 'L/100km', name: 'Litro por 100 Quilômetros', symbol: 'L/100km' },
          { id: 'mpg-us', name: 'Milhas por Galão (EUA)', symbol: 'mpg (US)' },
          { id: 'mpg-uk', name: 'Milhas por Galão (Reino Unido)', symbol: 'mpg (UK)' }
        ],
        customConvert: (value, fromUnit, toUnit) => {
          const num = parseFloat(value);
          if (isNaN(num) || num === 0) return '';
          // Base intermediária: L/100km
          // 1 milha = 1,609344 km; galão EUA = 3,785411784 L; galão UK = 4,54609 L
          const MPG_US = 235.214583;   // 100 * 3,785411784 / 1,609344
          const MPG_UK = 282.480936;   // 100 * 4,54609 / 1,609344
          const toBase = {
            'km/l': (v) => 100 / v,
            'L/100km': (v) => v,
            'mpg-us': (v) => MPG_US / v,
            'mpg-uk': (v) => MPG_UK / v
          };
          const fromBase = {
            'km/l': (b) => 100 / b,
            'L/100km': (b) => b,
            'mpg-us': (b) => MPG_US / b,
            'mpg-uk': (b) => MPG_UK / b
          };
          if (!toBase[fromUnit] || !fromBase[toUnit]) return '';
          return fromBase[toUnit](toBase[fromUnit](num));
        }
      },
      {
        id: 'culinaria',
        name: 'Medidas Culinárias',
        description: 'Converta medidas de cozinha: xícara, colher de sopa, colher de chá, onça fluída, ml e litro.',
        isTemperature: false,
        units: [
          { id: 'ml', name: 'Mililitro', symbol: 'ml', factor: 1 },
          { id: 'l', name: 'Litro', symbol: 'L', factor: 1000 },
          { id: 'xicara', name: 'Xícara', symbol: 'xc', factor: 240 },
          { id: 'colher-sopa', name: 'Colher de Sopa', symbol: 'col. sopa', factor: 15 },
          { id: 'colher-cha', name: 'Colher de Chá', symbol: 'col. chá', factor: 5 },
          { id: 'fl-oz', name: 'Onça Fluída (EUA)', symbol: 'fl oz', factor: 29.5735 }
        ]
      },
      {
        id: 'culinaria-gramas',
        name: 'Xícara para Gramas por Ingrediente',
        description: 'Converta xícaras para gramas por ingrediente (farinha de trigo, açúcar e manteiga). A massa depende da densidade de cada ingrediente.',
        isTemperature: false,
        units: [
          { id: 'farinha-xicara', name: 'Xícara de Farinha de Trigo', symbol: 'xc', factor: 120 },
          { id: 'farinha-grama', name: 'Grama de Farinha de Trigo', symbol: 'g', factor: 1 },
          { id: 'acucar-xicara', name: 'Xícara de Açúcar', symbol: 'xc', factor: 200 },
          { id: 'acucar-grama', name: 'Grama de Açúcar', symbol: 'g', factor: 1 },
          { id: 'manteiga-xicara', name: 'Xícara de Manteiga', symbol: 'xc', factor: 225 },
          { id: 'manteiga-grama', name: 'Grama de Manteiga', symbol: 'g', factor: 1 }
        ]
      },
      {
        id: 'ritmo',
        name: 'Ritmo de Corrida',
        description: 'Converta ritmo de corrida entre min/km, min/milha, km/h e mph.',
        isTemperature: false,
        units: [
          { id: 'min/km', name: 'Minuto por Quilômetro', symbol: 'min/km' },
          { id: 'min/mi', name: 'Minuto por Milha', symbol: 'min/mi' },
          { id: 'km/h', name: 'Quilômetro por Hora', symbol: 'km/h' },
          { id: 'mph', name: 'Milha por Hora', symbol: 'mph' }
        ],
        customConvert: (value, fromUnit, toUnit) => {
          const num = parseFloat(value);
          if (isNaN(num) || num === 0) return '';
          // Base intermediária: km/h. 1 milha = 1,609344 km.
          const MI = 1.609344;
          const MIN_MI = 60 * MI; // 96,56064
          const toBase = {
            'min/km': (v) => 60 / v,
            'min/mi': (v) => MIN_MI / v,
            'km/h': (v) => v,
            'mph': (v) => v * MI
          };
          const fromBase = {
            'min/km': (b) => 60 / b,
            'min/mi': (b) => MIN_MI / b,
            'km/h': (b) => b,
            'mph': (b) => b / MI
          };
          if (!toBase[fromUnit] || !fromBase[toUnit]) return '';
          return fromBase[toUnit](toBase[fromUnit](num));
        }
      },
      {
        id: 'fuso-horario',
        name: 'Fuso Horário entre Capitais',
        description: 'Converta data e hora entre capitais do mundo com regras de horário de verão.',
        isTimezone: true,
        units: []
      }
    ]
  },
  {
    id: 'engineering',
    name: 'Conversores de Engenharia',
    converters: [
      { 
        id: 'density', 
        name: 'Densidade', 
        description: 'Converta unidades de densidade.', 
        units: genUnits('kg/m³', 'kg/m³', [{sym: 'g/cm³', name: 'g/cm³', factor: 1000}]) 
      },
      { 
        id: 'vel_angular', 
        name: 'Velocidade Angular', 
        description: 'Converta unidades de velocidade angular.', 
        units: genUnits('Radiano/segundo', 'rad/s', [{sym: 'rpm', name: 'Rotações por minuto', factor: 0.10472}]) 
      },
      {
        id: 'aceleracao',
        name: 'Aceleração',
        description: 'Converta aceleração entre m/s², km/h², ft/s², Galileo e in/s².',
        units: [
          { id: 'm/s2', name: 'Metro por segundo ao quadrado', symbol: 'm/s²', factor: 1 },
          { id: 'km/h2', name: 'Quilômetro por hora ao quadrado', symbol: 'km/h²', factor: 0.0000771605 },
          { id: 'ft/s2', name: 'Pé por segundo ao quadrado', symbol: 'ft/s²', factor: 0.3048 },
          { id: 'Gal', name: 'Galileo', symbol: 'Gal', factor: 0.01 },
          { id: 'in/s2', name: 'Polegada por segundo ao quadrado', symbol: 'in/s²', factor: 0.0254 }
        ]
      },
      {
        id: 'aceleracao-angular',
        name: 'Aceleração Angular',
        description: 'Converta aceleração angular entre rad/s², °/s², rev/s² e grad/s².',
        units: [
          { id: 'rad/s2', name: 'Radiano por segundo ao quadrado', symbol: 'rad/s²', factor: 1 },
          { id: 'deg/s2', name: 'Grau por segundo ao quadrado', symbol: '°/s²', factor: 0.0174533 },
          { id: 'rev/s2', name: 'Revolução por segundo ao quadrado', symbol: 'rev/s²', factor: 6.28319 },
          { id: 'grad/s2', name: 'Grado por segundo ao quadrado', symbol: 'grad/s²', factor: 0.015708 }
        ]
      },
      {
        id: 'volume-especifico',
        name: 'Volume Específico',
        description: 'Converta volume específico entre m³/kg, cm³/g, ft³/lb, L/kg e gal/lb.',
        units: [
          { id: 'm3/kg', name: 'Metro cúbico por quilograma', symbol: 'm³/kg', factor: 1 },
          { id: 'cm3/g', name: 'Centímetro cúbico por grama', symbol: 'cm³/g', factor: 0.001 },
          { id: 'ft3/lb', name: 'Pé cúbico por libra', symbol: 'ft³/lb', factor: 0.0624280 },
          { id: 'L/kg', name: 'Litro por quilograma', symbol: 'L/kg', factor: 0.001 },
          { id: 'gal/lb', name: 'Galão por libra', symbol: 'gal/lb', factor: 0.00834540 }
        ]
      },
      {
        id: 'momento-inercia',
        name: 'Momento de Inércia',
        description: 'Converta momento de inércia entre kg·m², g·cm², lb·ft², lb·in² e oz·in².',
        units: [
          { id: 'kg.m2', name: 'Quilograma metro quadrado', symbol: 'kg·m²', factor: 1 },
          { id: 'g.cm2', name: 'Grama centímetro quadrado', symbol: 'g·cm²', factor: 0.0000001 },
          { id: 'lb.ft2', name: 'Libra pé quadrado', symbol: 'lb·ft²', factor: 0.0421401 },
          { id: 'lb.in2', name: 'Libra polegada quadrada', symbol: 'lb·in²', factor: 0.000292640 },
          { id: 'oz.in2', name: 'Onça polegada quadrada', symbol: 'oz·in²', factor: 0.00001829 }
        ]
      },
      {
        id: 'torque',
        name: 'Torque (Momento de Força)',
        description: 'Converta torque entre N·m, kN·m, lbf·ft, lbf·in, kgf·m e dyn·cm.',
        units: [
          { id: 'N.m', name: 'Newton metro', symbol: 'N·m', factor: 1 },
          { id: 'kN.m', name: 'Quilonewton metro', symbol: 'kN·m', factor: 1000 },
          { id: 'lbf.ft', name: 'Libra-força pé', symbol: 'lbf·ft', factor: 1.35582 },
          { id: 'lbf.in', name: 'Libra-força polegada', symbol: 'lbf·in', factor: 0.112985 },
          { id: 'kgf.m', name: 'Quilograma-força metro', symbol: 'kgf·m', factor: 9.80665 },
          { id: 'dyn.cm', name: 'Dina centímetro', symbol: 'dyn·cm', factor: 0.0000001 }
        ]
      },
      {
        id: 'pressure',
        name: 'Pressão',
        description: 'Converta unidades de pressão como Pascal, Bar e PSI.',
        units: [
          { id: 'Pa', name: 'Pascal', symbol: 'Pa', factor: 1 },
          { id: 'bar', name: 'Bar', symbol: 'bar', factor: 100000 },
          { id: 'psi', name: 'Libra por polegada quadrada', symbol: 'psi', factor: 6894.76 },
          { id: 'atm', name: 'Atmosfera padrão', symbol: 'atm', factor: 101325 }
        ]
      },
      {
        id: 'energy',
        name: 'Energia',
        description: 'Converta unidades de energia, trabalho e calor.',
        units: [
          { id: 'J', name: 'Joule', symbol: 'J', factor: 1 },
          { id: 'kJ', name: 'Quilojoule', symbol: 'kJ', factor: 1000 },
          { id: 'cal', name: 'Caloria', symbol: 'cal', factor: 4.184 },
          { id: 'kcal', name: 'Quilocaloria', symbol: 'kcal', factor: 4184 },
          { id: 'kWh', name: 'Quilowatt-hora', symbol: 'kWh', factor: 3600000 }
        ]
      },
      {
        id: 'angulo',
        name: 'Ângulo',
        description: 'Converta unidades de ângulo como graus, radianos e grados.',
        units: [
          { id: 'deg', name: 'Grau', factor: 1 },
          { id: 'rad', name: 'Radiano', factor: 57.2957795130823 },
          { id: 'gon', name: 'Grado', factor: 0.9 },
          { id: 'arcmin', name: 'Minuto de Arco', factor: 0.0166667 },
          { id: 'arcsec', name: 'Segundo de Arco', factor: 0.000277778 },
          { id: 'rev', name: 'Volta Completa', factor: 360 }
        ]
      },
      {
        id: 'potencia',
        name: 'Potência',
        description: 'Converta unidades de potência como watts, cavalo-vapor e horsepower.',
        units: [
          { id: 'W', name: 'Watt', factor: 1 },
          { id: 'mW', name: 'Miliwatt', factor: 0.001 },
          { id: 'kW', name: 'Quilowatt', factor: 1000 },
          { id: 'MW', name: 'Megawatt', factor: 1000000 },
          { id: 'CV', name: 'Cavalo-vapor', factor: 735.499 },
          { id: 'hp', name: 'Horsepower', factor: 745.7 },
          { id: 'BTU/h', name: 'BTU por Hora', factor: 0.293071 }
        ]
      },
      {
        id: 'forca',
        name: 'Força',
        description: 'Converta unidades de força como newton, quilograma-força e libra-força.',
        units: [
          { id: 'N', name: 'Newton', factor: 1 },
          { id: 'kN', name: 'Quilonewton', factor: 1000 },
          { id: 'dyn', name: 'Dina', factor: 0.00001 },
          { id: 'lbf', name: 'Libra-força', factor: 4.44822 },
          { id: 'kgf', name: 'Quilograma-força', factor: 9.80665 },
          { id: 'tf', name: 'Tonelada-força', factor: 9806.65 }
        ]
      },
      {
        id: 'frequencia',
        name: 'Frequência',
        description: 'Converta unidades de frequência como hertz, quilohertz e rotações por minuto.',
        units: [
          { id: 'Hz', name: 'Hertz', factor: 1 },
          { id: 'kHz', name: 'Quilohertz', factor: 1000 },
          { id: 'MHz', name: 'Megahertz', factor: 1000000 },
          { id: 'GHz', name: 'Gigahertz', factor: 1000000000 },
          { id: 'rpm', name: 'Rotações por Minuto', factor: 0.0166667 }
        ]
      },
      {
        id: 'nivel-som',
        name: 'Nível de Som',
        description: 'Converta unidades de nível sonoro como decibel, bel e neper.',
        units: [
          { id: 'dB', name: 'Decibel', factor: 1 },
          { id: 'B', name: 'Bel', factor: 10 },
          { id: 'Np', name: 'Neper', factor: 8.6858896 }
        ]
      }
    ]
  },
  {
    id: 'heat',
    name: 'Conversores de Calor',
    converters: [
      {
        id: 'fuel-efficiency-mass',
        name: 'Eficiência de Combustível (Massa)',
        description: 'Converta unidades de eficiência de combustível baseadas em massa.',
        units: [
          { id: 'kg/MJ', name: 'Quilograma por Megajoule', symbol: 'kg/MJ', factor: 1 },
          { id: 'g/J', name: 'Grama por Joule', symbol: 'g/J', factor: 1000 },
          { id: 'lb/MMBtu', name: 'Libra por Milhão de Btu', symbol: 'lb/MMBtu', factor: 0.000429923 },
          { id: 'lb/Btu', name: 'Libra por Btu', symbol: 'lb/Btu', factor: 429.923 }
        ]
      },
      {
        id: 'fuel-efficiency-volume',
        name: 'Eficiência de Combustível (Volume)',
        description: 'Converta unidades de eficiência de combustível baseadas em volume.',
        units: [
          { id: 'L/MJ', name: 'Litro por Megajoule', symbol: 'L/MJ', factor: 1 },
          { id: 'mL/J', name: 'Mililitro por Joule', symbol: 'mL/J', factor: 1000 },
          { id: 'gal/MMBtu', name: 'Galão por Milhão de Btu', symbol: 'gal/MMBtu', factor: 0.00358788 },
          { id: 'gal/Btu', name: 'Galão por Btu', symbol: 'gal/Btu', factor: 3587.88 }
        ]
      },
      {
        id: 'temperature-interval',
        name: 'Intervalo de Temperatura',
        description: 'Converta intervalos e diferenças de temperatura.',
        units: [
          { id: 'K', name: 'Kelvin', symbol: 'K', factor: 1 },
          { id: 'C', name: 'Grau Celsius', symbol: '°C', factor: 1 },
          { id: 'F', name: 'Grau Fahrenheit', symbol: '°F', factor: 0.555556 },
          { id: 'R', name: 'Grau Rankine', symbol: '°R', factor: 0.555556 }
        ]
      },
      {
        id: 'thermal-expansion',
        name: 'Expansão Térmica',
        description: 'Converta coeficientes de expansão térmica.',
        units: [
          { id: '1/K', name: 'Por Kelvin', symbol: '1/K', factor: 1 },
          { id: '1/C', name: 'Por Grau Celsius', symbol: '1/°C', factor: 1 },
          { id: '1/F', name: 'Por Grau Fahrenheit', symbol: '1/°F', factor: 1.8 },
          { id: '1/R', name: 'Por Grau Rankine', symbol: '1/°R', factor: 1.8 }
        ]
      },
      {
        id: 'thermal-resistance',
        name: 'Resistência Térmica',
        description: 'Converta unidades de resistência e isolamento térmico.',
        units: [
          { id: 'K/W', name: 'Kelvin por Watt', symbol: 'K/W', factor: 1 },
          { id: 'C/W', name: 'Grau Celsius por Watt', symbol: '°C/W', factor: 1 },
          { id: 'F.h/Btu', name: 'Grau Fahrenheit hora por Btu', symbol: '°F·h/Btu', factor: 1.89869 },
          { id: 'K.m/W', name: 'Kelvin metro por Watt', symbol: 'K·m/W', factor: 1 }
        ]
      },
      {
        id: 'thermal-conductivity',
        name: 'Condutividade Térmica',
        description: 'Converta unidades de condutividade térmica e condução de calor.',
        units: [
          { id: 'W/m.K', name: 'Watt por metro Kelvin', symbol: 'W/m·K', factor: 1 },
          { id: 'W/m.C', name: 'Watt por metro Celsius', symbol: 'W/m·°C', factor: 1 },
          { id: 'Btu/h.ft.F', name: 'Btu por hora pé Fahrenheit', symbol: 'Btu/h·ft·°F', factor: 1.73074 },
          { id: 'cal/s.cm.C', name: 'Caloria por segundo centímetro Celsius', symbol: 'cal/s·cm·°C', factor: 418.4 }
        ]
      },
      {
        id: 'specific-heat-capacity',
        name: 'Capacidade Calorífica Específica',
        description: 'Converta unidades de capacidade calorífica específica (calor específico).',
        units: [
          { id: 'J/kg.K', name: 'Joule por quilograma Kelvin', symbol: 'J/kg·K', factor: 1 },
          { id: 'J/kg.C', name: 'Joule por quilograma Celsius', symbol: 'J/kg·°C', factor: 1 },
          { id: 'cal/g.C', name: 'Caloria por grama Celsius', symbol: 'cal/g·°C', factor: 4184 },
          { id: 'Btu/lb.F', name: 'Btu por libra Fahrenheit', symbol: 'Btu/lb·°F', factor: 4186.8 }
        ]
      },
      {
        id: 'thermal-energy-density',
        name: 'Densidade de Energia Térmica',
        description: 'Converta unidades de densidade de energia térmica por volume.',
        units: [
          { id: 'J/m3', name: 'Joule por metro cúbico', symbol: 'J/m³', factor: 1 },
          { id: 'MJ/m3', name: 'Megajoule por metro cúbico', symbol: 'MJ/m³', factor: 1000000 },
          { id: 'Btu/ft3', name: 'Btu por pé cúbico', symbol: 'Btu/ft³', factor: 37258.9 },
          { id: 'cal/cm3', name: 'Caloria por centímetro cúbico', symbol: 'cal/cm³', factor: 4184000 }
        ]
      },
      {
        id: 'heat-flux-density',
        name: 'Densidade de Fluxo de Calor',
        description: 'Converta unidades de densidade de fluxo de calor.',
        units: [
          { id: 'W/m2', name: 'Watt por metro quadrado', symbol: 'W/m²', factor: 1 },
          { id: 'kW/m2', name: 'Quilowatt por metro quadrado', symbol: 'kW/m²', factor: 1000 },
          { id: 'Btu/h.ft2', name: 'Btu por hora pé quadrado', symbol: 'Btu/h·ft²', factor: 3.15459 },
          { id: 'cal/s.cm2', name: 'Caloria por segundo centímetro quadrado', symbol: 'cal/s·cm²', factor: 41840 }
        ]
      },
      {
        id: 'heat-transfer-coefficient',
        name: 'Coeficiente de Transferência de Calor',
        description: 'Converta coeficientes de transferência de calor.',
        units: [
          { id: 'W/m2.K', name: 'Watt por metro quadrado Kelvin', symbol: 'W/m²·K', factor: 1 },
          { id: 'W/m2.C', name: 'Watt por metro quadrado Celsius', symbol: 'W/m²·°C', factor: 1 },
          { id: 'Btu/h.ft2.F', name: 'Btu por hora pé quadrado Fahrenheit', symbol: 'Btu/h·ft²·°F', factor: 5.67826 },
          { id: 'cal/s.cm2.C', name: 'Caloria por segundo centímetro quadrado Celsius', symbol: 'cal/s·cm²·°C', factor: 41840 }
        ]
      }
    ]
  },
  {
    id: 'fluids',
    name: 'Conversores de Fluidos',
    converters: [
      {
        id: 'volumetric-flow-rate',
        name: 'Vazão (Fluxo)',
        description: 'Converta unidades de vazão volumétrica e fluxo.',
        units: [
          { id: 'm3/s', name: 'Metro cúbico por segundo', symbol: 'm³/s', factor: 1 },
          { id: 'm3/min', name: 'Metro cúbico por minuto', symbol: 'm³/min', factor: 0.016666666666666666 },
          { id: 'm3/h', name: 'Metro cúbico por hora', symbol: 'm³/h', factor: 0.0002777777777777778 },
          { id: 'L/s', name: 'Litro por segundo', symbol: 'L/s', factor: 0.001 },
          { id: 'L/min', name: 'Litro por minuto', symbol: 'L/min', factor: 0.000016666666666666666 },
          { id: 'L/h', name: 'Litro por hora', symbol: 'L/h', factor: 2.777777777777778e-7 },
          { id: 'ft3/s', name: 'Pé cúbico por segundo', symbol: 'ft³/s', factor: 0.0283168 },
          { id: 'ft3/min', name: 'Pé cúbico por minuto', symbol: 'ft³/min', factor: 0.00047194666666666664 },
          { id: 'gal/s', name: 'Galão por segundo', symbol: 'gal/s', factor: 0.00378541 },
          { id: 'gal/min', name: 'Galão por minuto', symbol: 'gal/min', factor: 0.00006309016666666666 },
          { id: 'gal/h', name: 'Galão por hora', symbol: 'gal/h', factor: 0.0000010515027777777777 }
        ]
      },
      {
        id: 'mass-flow-rate',
        name: 'Vazão de Massa',
        description: 'Converta unidades de vazão e fluxo de massa.',
        units: [
          { id: 'kg/s', name: 'Quilograma por segundo', symbol: 'kg/s', factor: 1 },
          { id: 'kg/min', name: 'Quilograma por minuto', symbol: 'kg/min', factor: 0.016666666666666666 },
          { id: 'kg/h', name: 'Quilograma por hora', symbol: 'kg/h', factor: 0.0002777777777777778 },
          { id: 'g/s', name: 'Grama por segundo', symbol: 'g/s', factor: 0.001 },
          { id: 'g/min', name: 'Grama por minuto', symbol: 'g/min', factor: 0.000016666666666666666 },
          { id: 'g/h', name: 'Grama por hora', symbol: 'g/h', factor: 2.777777777777778e-7 },
          { id: 'lb/s', name: 'Libra por segundo', symbol: 'lb/s', factor: 0.453592 },
          { id: 'lb/min', name: 'Libra por minuto', symbol: 'lb/min', factor: 0.007559866666666666 },
          { id: 'lb/h', name: 'Libra por hora', symbol: 'lb/h', factor: 0.00012599777777777778 },
          { id: 't/h', name: 'Tonelada por hora', symbol: 't/h', factor: 0.2777777777777778 }
        ]
      },
      {
        id: 'molar-flow-rate',
        name: 'Vazão Molar',
        description: 'Converta unidades de vazão molar e fluxo molar.',
        units: [
          { id: 'mol/s', name: 'Mol por segundo', symbol: 'mol/s', factor: 1 },
          { id: 'mol/min', name: 'Mol por minuto', symbol: 'mol/min', factor: 0.016666666666666666 },
          { id: 'mol/h', name: 'Mol por hora', symbol: 'mol/h', factor: 0.0002777777777777778 },
          { id: 'kmol/s', name: 'Quilomol por segundo', symbol: 'kmol/s', factor: 1000 },
          { id: 'kmol/min', name: 'Quilomol por minuto', symbol: 'kmol/min', factor: 16.666666666666668 },
          { id: 'kmol/h', name: 'Quilomol por hora', symbol: 'kmol/h', factor: 0.2777777777777778 }
        ]
      },
      {
        id: 'mass-flux-density',
        name: 'Densidade de Fluxo de Massa',
        description: 'Converta densidade de fluxo de massa por área e tempo.',
        units: [
          { id: 'kg/m2.s', name: 'Quilograma por metro quadrado por segundo', symbol: 'kg/m²·s', factor: 1 },
          { id: 'g/cm2.s', name: 'Grama por centímetro quadrado por segundo', symbol: 'g/cm²·s', factor: 10 },
          { id: 'lb/ft2.s', name: 'Libra por pé quadrado por segundo', symbol: 'lb/ft²·s', factor: 4.88243 },
          { id: 'lb/in2.s', name: 'Libra por polegada quadrada por segundo', symbol: 'lb/in²·s', factor: 703.070 }
        ]
      },
      {
        id: 'molar-concentration',
        name: 'Concentração Molar',
        description: 'Converta unidades de concentração molar.',
        units: [
          { id: 'mol/L', name: 'Mol por litro', symbol: 'mol/L', factor: 1 },
          { id: 'mol/m3', name: 'Mol por metro cúbico', symbol: 'mol/m³', factor: 0.001 },
          { id: 'mmol/L', name: 'Milimol por litro', symbol: 'mmol/L', factor: 0.001 },
          { id: 'umol/L', name: 'Micromol por litro', symbol: 'μmol/L', factor: 0.000001 },
          { id: 'mol/cm3', name: 'Mol por centímetro cúbico', symbol: 'mol/cm³', factor: 1000 }
        ]
      },
      {
        id: 'solution-concentration',
        name: 'Concentração de Solução',
        description: 'Converta concentrações de soluções e misturas.',
        units: [
          { id: 'g/L', name: 'Grama por litro', symbol: 'g/L', factor: 1 },
          { id: 'mg/L', name: 'Miligrama por litro', symbol: 'mg/L', factor: 0.001 },
          { id: 'ug/L', name: 'Micrograma por litro', symbol: 'μg/L', factor: 0.000001 },
          { id: 'g/m3', name: 'Grama por metro cúbico', symbol: 'g/m³', factor: 0.001 },
          { id: 'kg/m3', name: 'Quilograma por metro cúbico', symbol: 'kg/m³', factor: 1 },
          { id: 'lb/gal', name: 'Libra por galão', symbol: 'lb/gal', factor: 119.826 },
          { id: 'oz/gal', name: 'Onça por galão', symbol: 'oz/gal', factor: 7.48915 }
        ]
      },
      {
        id: 'dynamic-viscosity',
        name: 'Viscosidade Dinâmica',
        description: 'Converta unidades de viscosidade dinâmica.',
        units: [
          { id: 'Pa.s', name: 'Pascal-segundo', symbol: 'Pa·s', factor: 1 },
          { id: 'cP', name: 'Centipoise', symbol: 'cP', factor: 0.001 },
          { id: 'P', name: 'Poise', symbol: 'P', factor: 0.1 },
          { id: 'lb/ft.s', name: 'Libra por pé-segundo', symbol: 'lb/ft·s', factor: 1.48816 },
          { id: 'lbf.s/ft2', name: 'Libra-força segundo por pé quadrado', symbol: 'lbf·s/ft²', factor: 47.8803 }
        ]
      },
      {
        id: 'kinematic-viscosity',
        name: 'Viscosidade Cinemática',
        description: 'Converta unidades de viscosidade cinemática.',
        units: [
          { id: 'm2/s', name: 'Metro quadrado por segundo', symbol: 'm²/s', factor: 1 },
          { id: 'cm2/s', name: 'Centímetro quadrado por segundo', symbol: 'cm²/s', factor: 0.0001 },
          { id: 'St', name: 'Stokes', symbol: 'St', factor: 0.0001 },
          { id: 'cSt', name: 'Centistokes', symbol: 'cSt', factor: 0.000001 },
          { id: 'ft2/s', name: 'Pé quadrado por segundo', symbol: 'ft²/s', factor: 0.092903 },
          { id: 'in2/s', name: 'Polegada quadrada por segundo', symbol: 'in²/s', factor: 0.00064516 }
        ]
      },
      {
        id: 'surface-tension',
        name: 'Tensão Superficial',
        description: 'Converta unidades de tensão superficial.',
        units: [
          { id: 'N/m', name: 'Newton por metro', symbol: 'N/m', factor: 1 },
          { id: 'mN/m', name: 'Milinewton por metro', symbol: 'mN/m', factor: 0.001 },
          { id: 'dyn/cm', name: 'Dina por centímetro', symbol: 'dyn/cm', factor: 0.001 },
          { id: 'erg/cm2', name: 'Erg por centímetro quadrado', symbol: 'erg/cm²', factor: 0.001 },
          { id: 'lbf/in', name: 'Libra-força por polegada', symbol: 'lbf/in', factor: 175.127 }
        ]
      },
      {
        id: 'permeability',
        name: 'Permeabilidade',
        description: 'Converta unidades de permeabilidade de fluidos.',
        units: [
          { id: 'm2', name: 'Metro quadrado', symbol: 'm²', factor: 1 },
          { id: 'cm2', name: 'Centímetro quadrado', symbol: 'cm²', factor: 0.0001 },
          { id: 'D', name: 'Darcy', symbol: 'D', factor: 9.86923e-13 },
          { id: 'mD', name: 'Milidarcy', symbol: 'mD', factor: 9.86923e-16 },
          { id: 'in2', name: 'Polegada quadrada', symbol: 'in²', factor: 0.00064516 },
          { id: 'ft2', name: 'Pé quadrado', symbol: 'ft²', factor: 0.092903 },
          { id: 'b', name: 'Barn', symbol: 'b', factor: 1e-28 }
        ]
      },
      {
        id: 'ppm',
        name: 'Partes por Milhão (PPM)',
        description: 'Converta entre ppm, ppb, ppt, por cento e permilagem.',
        isTemperature: false,
        units: [
          { id: 'ppm', name: 'Partes por Milhão', symbol: 'ppm', factor: 0.000001 },
          { id: 'ppb', name: 'Partes por Bilhão', symbol: 'ppb', factor: 0.000000001 },
          { id: 'ppt', name: 'Partes por Trilhão', symbol: 'ppt', factor: 0.000000000001 },
          { id: 'percent', name: 'Por Cento', symbol: '%', factor: 0.01 },
          { id: 'permille', name: 'Permilagem', symbol: '‰', factor: 0.001 }
        ]
      }
    ]
  },
  {
    id: 'light',
    name: 'Conversores de Luz',
    converters: [
      {
        id: 'luminance',
        name: 'Luminância',
        description: 'Converta unidades de luminância.',
        units: [
          { id: 'cd/m2', name: 'Candela por metro quadrado', symbol: 'cd/m²', factor: 1 },
          { id: 'cd/cm2', name: 'Candela por centímetro quadrado', symbol: 'cd/cm²', factor: 10000 },
          { id: 'cd/ft2', name: 'Candela por pé quadrado', symbol: 'cd/ft²', factor: 10.7639 },
          { id: 'cd/in2', name: 'Candela por polegada quadrada', symbol: 'cd/in²', factor: 1550.003 },
          { id: 'fL', name: 'Foot-lambert', symbol: 'fL', factor: 3.42626 },
          { id: 'L', name: 'Lambert', symbol: 'L', factor: 3183.10 },
          { id: 'nt', name: 'Nit', symbol: 'nt', factor: 1 }
        ]
      },
      {
        id: 'luminous-intensity',
        name: 'Intensidade Luminosa',
        description: 'Converta unidades de intensidade luminosa.',
        units: [
          { id: 'cd', name: 'Candela', symbol: 'cd', factor: 1 },
          { id: 'cp', name: 'Candlepower', symbol: 'cp', factor: 0.981747 },
          { id: 'lm/sr', name: 'Lumen por esferorradiano', symbol: 'lm/sr', factor: 1 }
        ]
      },
      {
        id: 'illumination',
        name: 'Iluminação',
        description: 'Converta unidades de iluminação.',
        units: genUnits('Lux', 'lx', [{sym: 'fc', name: 'Foot-candle', factor: 10.764}])
      },
      {
        id: 'digital-image-resolution',
        name: 'Resolução de Imagem Digital',
        description: 'Converta unidades de resolução de imagem digital.',
        units: [
          { id: 'ppi', name: 'Pixel por polegada', symbol: 'ppi', factor: 1 },
          { id: 'ppc', name: 'Pixel por centímetro', symbol: 'ppc', factor: 0.393701 },
          { id: 'dpi', name: 'Ponto por polegada', symbol: 'dpi', factor: 1 },
          { id: 'dpc', name: 'Ponto por centímetro', symbol: 'dpc', factor: 0.393701 }
        ]
      },
      {
        id: 'frequency-wavelength',
        name: 'Frequência de Comprimento de Onda',
        description: 'Converta unidades de frequência.',
        units: [
          { id: 'Hz', name: 'Hertz', symbol: 'Hz', factor: 1 },
          { id: 'kHz', name: 'Quilohertz', symbol: 'kHz', factor: 1000 },
          { id: 'MHz', name: 'Megahertz', symbol: 'MHz', factor: 1000000 },
          { id: 'GHz', name: 'Gigahertz', symbol: 'GHz', factor: 1000000000 },
          { id: 'THz', name: 'Terahertz', symbol: 'THz', factor: 1000000000000 }
        ]
      }
    ]
  },
  {
    id: 'electricity',
    name: 'Conversores de Eletricidade',
    converters: [
      { id: 'charge', name: 'Carga', description: 'Converta unidades de carga elétrica.', units: genUnits('Coulomb', 'C', [{sym: 'Ah', name: 'Ampere-hora', factor: 3600}]) },
      { id: 'current', name: 'Corrente', description: 'Converta unidades de corrente elétrica.', units: genUnits('Ampere', 'A', [{sym: 'mA', name: 'Miliampere', factor: 0.001}]) },
      {
        id: 'voltage',
        name: 'Potencial Elétrico',
        description: 'Converta unidades de tensão elétrica e potencial elétrico.',
        units: [
          { id: 'V', name: 'Volt', symbol: 'V', factor: 1 },
          { id: 'mV', name: 'Milivolt', symbol: 'mV', factor: 0.001 },
          { id: 'uV', name: 'Microvolt', symbol: 'μV', factor: 0.000001 },
          { id: 'nV', name: 'Nanovolt', symbol: 'nV', factor: 0.000000001 },
          { id: 'MV', name: 'Megavolt', symbol: 'MV', factor: 1000000 },
          { id: 'GV', name: 'Gigavolt', symbol: 'GV', factor: 1000000000 },
          { id: 'kV', name: 'Quilovolt', symbol: 'kV', factor: 1000 },
          { id: 'abV', name: 'Abvolt', symbol: 'abV', factor: 0.00000001 }
        ]
      },
      {
        id: 'linear-charge-density',
        name: 'Densidade de Carga Linear',
        description: 'Converta unidades de densidade de carga linear.',
        units: [
          { id: 'C/m', name: 'Coulomb por metro', symbol: 'C/m', factor: 1 },
          { id: 'C/cm', name: 'Coulomb por centímetro', symbol: 'C/cm', factor: 100 },
          { id: 'C/mm', name: 'Coulomb por milímetro', symbol: 'C/mm', factor: 1000 },
          { id: 'uC/m', name: 'Microcoulomb por metro', symbol: 'μC/m', factor: 1e-6 },
          { id: 'nC/m', name: 'Nanocoulomb por metro', symbol: 'nC/m', factor: 1e-9 }
        ]
      },
      {
        id: 'surface-charge-density',
        name: 'Densidade de Carga Superficial',
        description: 'Converta unidades de densidade de carga superficial.',
        units: [
          { id: 'C/m2', name: 'Coulomb por metro quadrado', symbol: 'C/m²', factor: 1 },
          { id: 'C/cm2', name: 'Coulomb por centímetro quadrado', symbol: 'C/cm²', factor: 10000 },
          { id: 'C/mm2', name: 'Coulomb por milímetro quadrado', symbol: 'C/mm²', factor: 1e6 },
          { id: 'uC/m2', name: 'Microcoulomb por metro quadrado', symbol: 'μC/m²', factor: 1e-6 },
          { id: 'nC/m2', name: 'Nanocoulomb por metro quadrado', symbol: 'nC/m²', factor: 1e-9 }
        ]
      },
      {
        id: 'volume-charge-density',
        name: 'Densidade de Carga Volumétrica',
        description: 'Converta unidades de densidade de carga volumétrica.',
        units: [
          { id: 'C/m3', name: 'Coulomb por metro cúbico', symbol: 'C/m³', factor: 1 },
          { id: 'C/cm3', name: 'Coulomb por centímetro cúbico', symbol: 'C/cm³', factor: 1e6 },
          { id: 'C/mm3', name: 'Coulomb por milímetro cúbico', symbol: 'C/mm³', factor: 1e9 },
          { id: 'uC/m3', name: 'Microcoulomb por metro cúbico', symbol: 'μC/m³', factor: 1e-6 },
          { id: 'nC/m3', name: 'Nanocoulomb por metro cúbico', symbol: 'nC/m³', factor: 1e-9 }
        ]
      },
      {
        id: 'linear-current-density',
        name: 'Densidade de Corrente Linear',
        description: 'Converta unidades de densidade de corrente linear.',
        units: [
          { id: 'A/m', name: 'Ampere por metro', symbol: 'A/m', factor: 1 },
          { id: 'A/cm', name: 'Ampere por centímetro', symbol: 'A/cm', factor: 100 },
          { id: 'A/mm', name: 'Ampere por milímetro', symbol: 'A/mm', factor: 1000 },
          { id: 'mA/m', name: 'Miliampere por metro', symbol: 'mA/m', factor: 1e-3 }
        ]
      },
      {
        id: 'surface-current-density',
        name: 'Densidade de Corrente Superficial',
        description: 'Converta unidades de densidade de corrente superficial.',
        units: [
          { id: 'A/m2', name: 'Ampere por metro quadrado', symbol: 'A/m²', factor: 1 },
          { id: 'A/cm2', name: 'Ampere por centímetro quadrado', symbol: 'A/cm²', factor: 10000 },
          { id: 'A/mm2', name: 'Ampere por milímetro quadrado', symbol: 'A/mm²', factor: 1e6 },
          { id: 'mA/m2', name: 'Miliampere por metro quadrado', symbol: 'mA/m²', factor: 1e-3 }
        ]
      },
      {
        id: 'electric-field-strength',
        name: 'Intensidade de Campo Elétrico',
        description: 'Converta unidades de intensidade de campo elétrico.',
        units: [
          { id: 'V/m', name: 'Volt por metro', symbol: 'V/m', factor: 1 },
          { id: 'V/cm', name: 'Volt por centímetro', symbol: 'V/cm', factor: 100 },
          { id: 'V/mm', name: 'Volt por milímetro', symbol: 'V/mm', factor: 1000 },
          { id: 'kV/m', name: 'Quilovolt por metro', symbol: 'kV/m', factor: 1000 },
          { id: 'N/C', name: 'Newton por coulomb', symbol: 'N/C', factor: 1 }
        ]
      },
      {
        id: 'electrical-resistance',
        name: 'Resistência Elétrica',
        description: 'Converta unidades de resistência elétrica.',
        units: [
          { id: 'ohm', name: 'Ohm', symbol: 'Ω', factor: 1 },
          { id: 'mohm', name: 'Miliohm', symbol: 'mΩ', factor: 1e-3 },
          { id: 'uohm', name: 'Microohm', symbol: 'μΩ', factor: 1e-6 },
          { id: 'kohm', name: 'Quilo-ohm', symbol: 'kΩ', factor: 1000 },
          { id: 'Mohm', name: 'Megaohm', symbol: 'MΩ', factor: 1e6 },
          { id: 'Gohm', name: 'Gigaohm', symbol: 'GΩ', factor: 1e9 }
        ]
      },
      {
        id: 'electrical-resistivity',
        name: 'Resistividade Elétrica',
        description: 'Converta unidades de resistividade elétrica.',
        units: [
          { id: 'ohm.m', name: 'Ohm metro', symbol: 'Ω·m', factor: 1 },
          { id: 'ohm.cm', name: 'Ohm centímetro', symbol: 'Ω·cm', factor: 0.01 },
          { id: 'ohm.mm', name: 'Ohm milímetro', symbol: 'Ω·mm', factor: 0.001 },
          { id: 'uohm.m', name: 'Microohm metro', symbol: 'μΩ·m', factor: 1e-6 },
          { id: 'kohm.m', name: 'Quilo-ohm metro', symbol: 'kΩ·m', factor: 1000 }
        ]
      },
      {
        id: 'electrical-conductance',
        name: 'Condutância Elétrica',
        description: 'Converta unidades de condutância elétrica.',
        units: [
          { id: 'S', name: 'Siemens', symbol: 'S', factor: 1 },
          { id: 'mS', name: 'Milisiemens', symbol: 'mS', factor: 1e-3 },
          { id: 'uS', name: 'Microsiemens', symbol: 'μS', factor: 1e-6 },
          { id: 'nS', name: 'Nanosiemens', symbol: 'nS', factor: 1e-9 },
          { id: 'mho', name: 'Mho', symbol: '℧', factor: 1 },
          { id: 'umho', name: 'Micromho', symbol: 'μ℧', factor: 1e-6 }
        ]
      },
      {
        id: 'electrical-conductivity',
        name: 'Condutividade Elétrica',
        description: 'Converta unidades de condutividade elétrica.',
        units: [
          { id: 'S/m', name: 'Siemens por metro', symbol: 'S/m', factor: 1 },
          { id: 'S/cm', name: 'Siemens por centímetro', symbol: 'S/cm', factor: 100 },
          { id: 'mS/m', name: 'Milisiemens por metro', symbol: 'mS/m', factor: 1e-3 },
          { id: 'uS/m', name: 'Microsiemens por metro', symbol: 'μS/m', factor: 1e-6 },
          { id: 'mho/m', name: 'Mho por metro', symbol: '℧/m', factor: 1 }
        ]
      },
      {
        id: 'electrostatic-capacitance',
        name: 'Capacitância Eletrostática',
        description: 'Converta unidades de capacitância eletrostática.',
        units: [
          { id: 'F', name: 'Farad', symbol: 'F', factor: 1 },
          { id: 'mF', name: 'Milifarad', symbol: 'mF', factor: 1e-3 },
          { id: 'uF', name: 'Microfarad', symbol: 'μF', factor: 1e-6 },
          { id: 'nF', name: 'Nanofarad', symbol: 'nF', factor: 1e-9 },
          { id: 'pF', name: 'Picofarad', symbol: 'pF', factor: 1e-12 },
          { id: 'abF', name: 'Abfarad', symbol: 'abF', factor: 1e9 }
        ]
      },
      {
        id: 'inductance',
        name: 'Indutância',
        description: 'Converta unidades de indutância.',
        units: [
          { id: 'H', name: 'Henry', symbol: 'H', factor: 1 },
          { id: 'mH', name: 'Milihenry', symbol: 'mH', factor: 0.001 },
          { id: 'uH', name: 'Microhenry', symbol: 'μH', factor: 0.000001 },
          { id: 'nH', name: 'Nanohenry', symbol: 'nH', factor: 0.000000001 },
          { id: 'pH', name: 'Picohenry', symbol: 'pH', factor: 0.000000000001 },
          { id: 'abH', name: 'Abhenry', symbol: 'abH', factor: 0.000000001 }
        ]
      },
      {
        id: 'potencia-dbm',
        name: 'Potência em dBm',
        description: 'Converta potência entre dBm, watt, miliwatt e quilowatt.',
        isTemperature: false,
        units: [
          { id: 'dBm', name: 'Decibel-miliwatt', symbol: 'dBm' },
          { id: 'W', name: 'Watt', symbol: 'W' },
          { id: 'mW', name: 'Miliwatt', symbol: 'mW' },
          { id: 'kW', name: 'Quilowatt', symbol: 'kW' }
        ],
        customConvert: (value, fromUnit, toUnit) => {
          const num = parseFloat(value);
          if (isNaN(num)) return '';
          // Base intermediária: mW (miliwatt)
          let mW;
          if (fromUnit === 'dBm') mW = Math.pow(10, num / 10);
          else if (fromUnit === 'W') mW = num * 1000;
          else if (fromUnit === 'mW') mW = num;
          else if (fromUnit === 'kW') mW = num * 1000000;
          else return '';
          if (toUnit === 'dBm') return 10 * Math.log10(mW);
          if (toUnit === 'W') return mW / 1000;
          if (toUnit === 'mW') return mW;
          if (toUnit === 'kW') return mW / 1000000;
          return '';
        }
      }
    ]
  },
  {
    id: 'magnetism',
    name: 'Magnetismo',
    description: 'Conversores de campo magnético e fluxo magnético.',
    converters: [
      {
        id: 'magnetomotive-force',
        name: 'Força Magnetomotriz',
        description: 'Converta unidades de força magnetomotriz como Ampere, Ampere-espira, Oersted e Gilbert.',
        units: [
          { id: 'A', name: 'Ampere', symbol: 'A', factor: 1 },
          { id: 'At', name: 'Ampere-espira', symbol: 'At', factor: 1 },
          { id: 'Oe', name: 'Oersted', symbol: 'Oe', factor: 0.795775 },
          { id: 'Gb', name: 'Gilbert', symbol: 'Gb', factor: 0.795775 }
        ]
      },
      {
        id: 'magnetic-field-intensity',
        name: 'Intensidade de Campo Magnético',
        description: 'Converta unidades de intensidade de campo magnético como Ampere/metro, Oersted e Ampere/centímetro.',
        units: [
          { id: 'A/m', name: 'Ampere por metro', symbol: 'A/m', factor: 1 },
          { id: 'Oe', name: 'Oersted', symbol: 'Oe', factor: 79.577 },
          { id: 'A/cm', name: 'Ampere por centímetro', symbol: 'A/cm', factor: 100 },
          { id: 'A/in', name: 'Ampere por polegada', symbol: 'A/in', factor: 39.3701 }
        ]
      },
      {
        id: 'magnetic-flux',
        name: 'Fluxo Magnético',
        description: 'Converta unidades de fluxo magnético como Weber, Maxwell e Volt-segundo.',
        units: [
          { id: 'Wb', name: 'Weber', symbol: 'Wb', factor: 1 },
          { id: 'mWb', name: 'Miliweber', symbol: 'mWb', factor: 0.001 },
          { id: 'uWb', name: 'Microweber', symbol: 'μWb', factor: 0.000001 },
          { id: 'Mx', name: 'Maxwell', symbol: 'Mx', factor: 0.00000001 },
          { id: 'V.s', name: 'Volt-segundo', symbol: 'V·s', factor: 1 }
        ]
      },
      {
        id: 'magnetic-flux-density',
        name: 'Densidade de Fluxo Magnético',
        description: 'Converta unidades de densidade de fluxo magnético como Tesla, Gauss e Weber/m².',
        units: [
          { id: 'T', name: 'Tesla', symbol: 'T', factor: 1 },
          { id: 'mT', name: 'Militela', symbol: 'mT', factor: 0.001 },
          { id: 'uT', name: 'Microtesla', symbol: 'μT', factor: 0.000001 },
          { id: 'nT', name: 'Nanotesla', symbol: 'nT', factor: 0.000000001 },
          { id: 'G', name: 'Gauss', symbol: 'G', factor: 0.0001 },
          { id: 'mG', name: 'Miligauss', symbol: 'mG', factor: 0.0000001 },
          { id: 'Wb/m2', name: 'Weber por metro quadrado', symbol: 'Wb/m²', factor: 1 }
        ]
      }
    ]
  },
  {
    id: 'radiology',
    name: 'Radiologia',
    description: 'Conversores de radiação, atividade radioativa e dose absorvida.',
    converters: [
      {
        id: 'radiacao',
        name: 'Radiação',
        description: 'Converter de Radiação - Converta entre Becquerel, Curie, Rutherford e outras unidades de radiação',
        units: [
          { id: 'Bq', name: 'Becquerel', symbol: 'Bq', factor: 1 },
          { id: 'Ci', name: 'Curie', symbol: 'Ci', factor: 37000000000 },
          { id: 'Rd', name: 'Rutherford', symbol: 'Rd', factor: 1000000 },
          { id: 'dps', name: 'Desintegrações por segundo', symbol: 'dps', factor: 1 },
          { id: 'dpm', name: 'Desintegrações por minuto', symbol: 'dpm', factor: 0.016666666666666666 }
        ]
      },
      {
        id: 'atividade-radiacao',
        name: 'Atividade de Radiação',
        description: 'Conversor de Atividade de Radiação - Converta entre Becquerel, Curie e múltiplos',
        units: [
          { id: 'Bq', name: 'Becquerel', symbol: 'Bq', factor: 1 },
          { id: 'kBq', name: 'Quilobecquerel', symbol: 'kBq', factor: 1000 },
          { id: 'MBq', name: 'Megabecquerel', symbol: 'MBq', factor: 1000000 },
          { id: 'GBq', name: 'Gigabecquerel', symbol: 'GBq', factor: 1000000000 },
          { id: 'TBq', name: 'Terabecquerel', symbol: 'TBq', factor: 1000000000000 },
          { id: 'Ci', name: 'Curie', symbol: 'Ci', factor: 37000000000 },
          { id: 'mCi', name: 'Milicurie', symbol: 'mCi', factor: 37000000 },
          { id: 'uCi', name: 'Microcurie', symbol: 'μCi', factor: 37000 },
          { id: 'nCi', name: 'Nanocurie', symbol: 'nCi', factor: 37 }
        ]
      },
      {
        id: 'exposicao-radiacao',
        name: 'Exposição à Radiação',
        description: 'Conversor de Exposição à Radiação - Converta entre Roentgen e Coulomb por quilograma',
        units: [
          { id: 'R', name: 'Roentgen', symbol: 'R', factor: 1 },
          { id: 'mR', name: 'Miliroentgen', symbol: 'mR', factor: 0.001 },
          { id: 'uR', name: 'Microroentgen', symbol: 'μR', factor: 0.000001 },
          { id: 'C/kg', name: 'Coulomb por quilograma', symbol: 'C/kg', factor: 3875.968992248062 },
          { id: 'mC/kg', name: 'Milicoulomb por quilograma', symbol: 'mC/kg', factor: 3.875968992248062 }
        ]
      },
      {
        id: 'dose-absorvida',
        name: 'Dose Absorvida',
        description: 'Conversor de Dose Absorvida - Converta entre Gray, Rad e Joule por quilograma',
        units: [
          { id: 'Gy', name: 'Gray', symbol: 'Gy', factor: 1 },
          { id: 'mGy', name: 'Miligray', symbol: 'mGy', factor: 0.001 },
          { id: 'uGy', name: 'Microgray', symbol: 'μGy', factor: 0.000001 },
          { id: 'rd', name: 'Rad', symbol: 'rd', factor: 0.01 },
          { id: 'mrd', name: 'Milirad', symbol: 'mrd', factor: 0.00001 },
          { id: 'J/kg', name: 'Joule por quilograma', symbol: 'J/kg', factor: 1 }
        ]
      }
    ]
  },
  {
    id: 'other',
    name: 'Outros Conversores',
    converters: [
      { id: 'data_storage', name: 'Armazenamento de Dados', description: 'Converta unidades de armazenamento de dados digitais.', units: genUnits('Byte', 'B', [{sym: 'KB', name: 'Kilobyte', factor: 1024}, {sym: 'MB', name: 'Megabyte', factor: 1048576}, {sym: 'GB', name: 'Gigabyte', factor: 1073741824}, {sym: 'TB', name: 'Terabyte', factor: 1099511627776}]) },
      { id: 'data_transfer', name: 'Transferência de Dados', description: 'Converta unidades de taxa de transferência de dados.', units: genUnits('Bit/segundo', 'bps', [{sym: 'Kbps', name: 'Kilobit/segundo', factor: 1000}, {sym: 'Mbps', name: 'Megabit/segundo', factor: 1000000}, {sym: 'Gbps', name: 'Gigabit/segundo', factor: 1000000000}]) },
      { id: 'typography', name: 'Tipografia', description: 'Converta unidades tipográficas.', units: genUnits('Ponto', 'pt', [{sym: 'px', name: 'Pixel', factor: 0.75}, {sym: 'em', name: 'Em', factor: 12}, {sym: 'rem', name: 'Rem', factor: 16}]) },
      {
        id: 'escala',
        name: 'Escala',
        description: 'Converta dimensões reais em escala (1:50, 1:100, etc.) para arquitetura, maquetes e mapas.',
        isTemperature: false,
        units: [
          { id: '1', name: 'Escala 1:1 (Real)', symbol: '1:1' },
          { id: '2', name: 'Escala 1:2', symbol: '1:2' },
          { id: '5', name: 'Escala 1:5', symbol: '1:5' },
          { id: '10', name: 'Escala 1:10', symbol: '1:10' },
          { id: '20', name: 'Escala 1:20', symbol: '1:20' },
          { id: '50', name: 'Escala 1:50', symbol: '1:50' },
          { id: '100', name: 'Escala 1:100', symbol: '1:100' },
          { id: '200', name: 'Escala 1:200', symbol: '1:200' },
          { id: '500', name: 'Escala 1:500', symbol: '1:500' },
          { id: '1000', name: 'Escala 1:1000', symbol: '1:1000' }
        ],
        customConvert: (value, fromUnit, toUnit) => {
          const num = parseFloat(value);
          if (isNaN(num)) return '';
          const fromDenom = parseFloat(fromUnit);
          const toDenom = parseFloat(toUnit);
          if (!fromDenom || !toDenom) return '';
          return num * (fromDenom / toDenom);
        }
      },
      {
        id: 'numeros-grandes',
        name: 'Números Grandes',
        description: 'Converta entre milhar, milhão, bilhão, trilhão e quadrilhão.',
        isTemperature: false,
        units: [
          { id: 'milhar', name: 'Milhar', symbol: '10³', factor: 1000 },
          { id: 'milhao', name: 'Milhão', symbol: '10⁶', factor: 1000000 },
          { id: 'bilhao', name: 'Bilhão', symbol: '10⁹', factor: 1000000000 },
          { id: 'trilhao', name: 'Trilhão', symbol: '10¹²', factor: 1000000000000 },
          { id: 'quadrilhao', name: 'Quadrilhão', symbol: '10¹⁵', factor: 1000000000000000 },
          { id: 'quintilhao', name: 'Quintilhão', symbol: '10¹⁸', factor: 1000000000000000000 }
        ]
      },
      {
        id: 'bases-numericas',
        name: 'Bases Numéricas (Binário, Decimal, Hexadecimal)',
        description: 'Converta entre binário, octal, decimal e hexadecimal. Digite o valor no campo de origem (ex.: 1010, FF, 377).',
        isTemperature: false,
        isTextInput: true,
        units: [
          { id: 'bin', name: 'Binário', symbol: 'base 2' },
          { id: 'oct', name: 'Octal', symbol: 'base 8' },
          { id: 'dec', name: 'Decimal', symbol: 'base 10' },
          { id: 'hex', name: 'Hexadecimal', symbol: 'base 16' }
        ],
        customConvert: (value, fromUnit, toUnit) => {
          const bases = { bin: 2, oct: 8, dec: 10, hex: 16 };
          const fromBase = bases[fromUnit];
          const toBase = bases[toUnit];
          if (!fromBase || !toBase) return '';
          const raw = String(value).trim();
          if (raw === '') return '';
          const clean = raw.replace(/^0[bxo]/i, '').replace(/_/g, '');
          const valid = { 2: /^[01]+$/, 8: /^[0-7]+$/, 10: /^\d+$/, 16: /^[0-9a-fA-F]+$/ };
          if (!valid[fromBase] || !valid[fromBase].test(clean)) return '';
          const n = parseInt(clean, fromBase);
          if (isNaN(n)) return '';
          if (toBase === 10) return String(n);
          if (toBase === 2) return n.toString(2);
          if (toBase === 8) return n.toString(8);
          if (toBase === 16) return n.toString(16).toUpperCase();
          return '';
        }
      },
      {
        id: 'pixels-dpi',
        name: 'Pixels para Polegadas (DPI)',
        description: 'Converta pixels para polegadas e centímetros conforme o DPI informado (72, 96, 150, 300 e 600 DPI). A conversão depende da resolução (DPI) escolhida.',
        isTemperature: false,
        units: [
          { id: 'px-72', name: 'Pixels (72 DPI)', symbol: 'px', factor: 1 },
          { id: 'in-72', name: 'Polegadas (72 DPI)', symbol: 'in', factor: 72 },
          { id: 'cm-72', name: 'Centímetros (72 DPI)', symbol: 'cm', factor: 72 / 2.54 },
          { id: 'px-96', name: 'Pixels (96 DPI)', symbol: 'px', factor: 1 },
          { id: 'in-96', name: 'Polegadas (96 DPI)', symbol: 'in', factor: 96 },
          { id: 'cm-96', name: 'Centímetros (96 DPI)', symbol: 'cm', factor: 96 / 2.54 },
          { id: 'px-150', name: 'Pixels (150 DPI)', symbol: 'px', factor: 1 },
          { id: 'in-150', name: 'Polegadas (150 DPI)', symbol: 'in', factor: 150 },
          { id: 'cm-150', name: 'Centímetros (150 DPI)', symbol: 'cm', factor: 150 / 2.54 },
          { id: 'px-300', name: 'Pixels (300 DPI)', symbol: 'px', factor: 1 },
          { id: 'in-300', name: 'Polegadas (300 DPI)', symbol: 'in', factor: 300 },
          { id: 'cm-300', name: 'Centímetros (300 DPI)', symbol: 'cm', factor: 300 / 2.54 },
          { id: 'px-600', name: 'Pixels (600 DPI)', symbol: 'px', factor: 1 },
          { id: 'in-600', name: 'Polegadas (600 DPI)', symbol: 'in', factor: 600 },
          { id: 'cm-600', name: 'Centímetros (600 DPI)', symbol: 'cm', factor: 600 / 2.54 }
        ]
      },
      {
        id: 'fracao-polegada',
        name: 'Fração de Polegada para Decimal',
        description: 'Converta frações de polegada (ex.: 1 1/2, 3/4, 5/8) para decimal e milímetros, e vice-versa. Aceita frações mistas.',
        isTemperature: false,
        isTextInput: true,
        units: [
          { id: 'frac', name: 'Polegada (Fração)', symbol: 'in' },
          { id: 'dec', name: 'Polegada (Decimal)', symbol: 'in' },
          { id: 'mm', name: 'Milímetro', symbol: 'mm' }
        ],
        customConvert: (value, fromUnit, toUnit) => {
          const parseInches = (v) => {
            const s = String(v).trim().replace(/,/g, '.');
            if (s === '') return NaN;
            const mixed = s.match(/^(\d+)\s*[-\s]\s*(\d+)\/(\d+)$/);
            if (mixed) {
              const d = parseInt(mixed[3]);
              return d === 0 ? NaN : parseInt(mixed[1]) + parseInt(mixed[2]) / d;
            }
            const frac = s.match(/^(\d+)\/(\d+)$/);
            if (frac) {
              const d = parseInt(frac[2]);
              return d === 0 ? NaN : parseInt(frac[1]) / d;
            }
            const n = parseFloat(s);
            return isNaN(n) ? NaN : n;
          };
          const toFrac = (n) => {
            if (isNaN(n)) return '';
            const sign = n < 0 ? '-' : '';
            const abs = Math.abs(n);
            const whole = Math.floor(abs);
            const rem = abs - whole;
            const denoms = [2, 4, 8, 16, 32, 64];
            let bestNum = 0, bestDen = 1, bestErr = rem;
            for (const d of denoms) {
              const num = Math.round(rem * d);
              const err = Math.abs(rem - num / d);
              if (err < bestErr - 1e-9) { bestErr = err; bestNum = num; bestDen = d; }
            }
            if (bestNum === 0) return sign + (whole || 0);
            if (whole === 0) return sign + bestNum + '/' + bestDen;
            return sign + whole + ' ' + bestNum + '/' + bestDen;
          };
          let inches;
          if (fromUnit === 'frac') inches = parseInches(value);
          else if (fromUnit === 'dec') inches = parseFloat(String(value).replace(/,/g, '.'));
          else if (fromUnit === 'mm') inches = parseFloat(String(value).replace(/,/g, '.')) / 25.4;
          else return '';
          if (isNaN(inches)) return '';
          if (toUnit === 'frac') return toFrac(inches);
          if (toUnit === 'dec') return String(parseFloat(inches.toFixed(6)));
          if (toUnit === 'mm') return String(parseFloat((inches * 25.4).toFixed(6)));
          return '';
        }
      },
      {
        id: 'cores',
        name: 'Conversor de Cores',
        description: 'Converta cores entre HEX, RGB, HSL e CMYK. Aceita #RRGGBB, rgb(), hsl() e valores com transparência (alfa).',
        isTemperature: false,
        isTextInput: true,
        units: [
          { id: 'hex', name: 'HEX', symbol: '#' },
          { id: 'rgb', name: 'RGB', symbol: 'rgb' },
          { id: 'hsl', name: 'HSL', symbol: 'hsl' },
          { id: 'cmyk', name: 'CMYK', symbol: 'cmyk' }
        ],
        customConvert: (value, fromUnit, toUnit) => {
          const clamp = (n, min, max) => Math.min(max, Math.max(min, n));
          const toHex2 = (n) => clamp(Math.round(n), 0, 255).toString(16).padStart(2, '0');

          const parseHex = (s) => {
            let h = String(s).trim().replace(/^#/, '');
            if (h.length === 3 || h.length === 4) h = h.split('').map(c => c + c).join('');
            if (h.length !== 6 && h.length !== 8) return null;
            if (!/^[0-9a-fA-F]+$/.test(h)) return null;
            const r = parseInt(h.slice(0, 2), 16);
            const g = parseInt(h.slice(2, 4), 16);
            const b = parseInt(h.slice(4, 6), 16);
            const a = h.length === 8 ? parseInt(h.slice(6, 8), 16) / 255 : 1;
            return { r, g, b, a };
          };

          const parseRgb = (s) => {
            const m = String(s).trim().match(/^rgba?\(\s*(\d+\.?\d*)\s*[,\s]\s*(\d+\.?\d*)\s*[,\s]\s*(\d+\.?\d*)\s*(?:[,/]\s*([\d.]+%?)\s*)?\)$/i);
            if (!m) return null;
            let a = 1;
            if (m[4] !== undefined) a = m[4].endsWith('%') ? clamp(parseFloat(m[4]) / 100, 0, 1) : clamp(parseFloat(m[4]), 0, 1);
            return { r: clamp(parseFloat(m[1]), 0, 255), g: clamp(parseFloat(m[2]), 0, 255), b: clamp(parseFloat(m[3]), 0, 255), a };
          };

          const parseHsl = (s) => {
            const m = String(s).trim().match(/^hsla?\(\s*(\d+\.?\d*)\s*(?:deg)?\s*[,\s]\s*(\d+\.?\d*)%?\s*[,\s]\s*(\d+\.?\d*)%?\s*(?:[,/]\s*([\d.]+%?)\s*)?\)$/i);
            if (!m) return null;
            const h = ((parseFloat(m[1]) % 360) + 360) % 360;
            const sat = clamp(parseFloat(m[2]) / 100, 0, 1);
            const lig = clamp(parseFloat(m[3]) / 100, 0, 1);
            let a = 1;
            if (m[4] !== undefined) a = m[4].endsWith('%') ? clamp(parseFloat(m[4]) / 100, 0, 1) : clamp(parseFloat(m[4]), 0, 1);
            const c = (1 - Math.abs(2 * lig - 1)) * sat;
            const x = c * (1 - Math.abs(((h / 60) % 2) - 1));
            const m2 = lig - c / 2;
            let r1, g1, b1;
            if (h < 60) [r1, g1, b1] = [c, x, 0];
            else if (h < 120) [r1, g1, b1] = [x, c, 0];
            else if (h < 180) [r1, g1, b1] = [0, c, x];
            else if (h < 240) [r1, g1, b1] = [0, x, c];
            else if (h < 300) [r1, g1, b1] = [x, 0, c];
            else [r1, g1, b1] = [c, 0, x];
            return { r: Math.round((r1 + m2) * 255), g: Math.round((g1 + m2) * 255), b: Math.round((b1 + m2) * 255), a };
          };

          const parseCmyk = (s) => {
            const m = String(s).trim().match(/^cmyk\(?\s*(\d+\.?\d*)%?\s*[,\s]\s*(\d+\.?\d*)%?\s*[,\s]\s*(\d+\.?\d*)%?\s*[,\s]\s*(\d+\.?\d*)%?\s*\)?$/i);
            if (!m) return null;
            const c = clamp(parseFloat(m[1]) / 100, 0, 1);
            const mg = clamp(parseFloat(m[2]) / 100, 0, 1);
            const y = clamp(parseFloat(m[3]) / 100, 0, 1);
            const k = clamp(parseFloat(m[4]) / 100, 0, 1);
            return {
              r: Math.round(255 * (1 - c) * (1 - k)),
              g: Math.round(255 * (1 - mg) * (1 - k)),
              b: Math.round(255 * (1 - y) * (1 - k)),
              a: 1
            };
          };

          let col = null;
          if (fromUnit === 'hex') col = parseHex(value);
          else if (fromUnit === 'rgb') col = parseRgb(value);
          else if (fromUnit === 'hsl') col = parseHsl(value);
          else if (fromUnit === 'cmyk') col = parseCmyk(value);
          if (!col) return '';

          const { r, g, b, a } = col;

          if (toUnit === 'hex') {
            const base = '#' + toHex2(r) + toHex2(g) + toHex2(b);
            if (a < 1) return (base + Math.round(a * 255).toString(16).padStart(2, '0')).toUpperCase();
            return base.toUpperCase();
          }
          if (toUnit === 'rgb') {
            const rr = Math.round(r), gg = Math.round(g), bb = Math.round(b);
            if (a < 1) return `rgba(${rr}, ${gg}, ${bb}, ${parseFloat(a.toFixed(3))})`;
            return `rgb(${rr}, ${gg}, ${bb})`;
          }
          if (toUnit === 'hsl') {
            const rn = r / 255, gn = g / 255, bn = b / 255;
            const max = Math.max(rn, gn, bn), min = Math.min(rn, gn, bn);
            const lig = (max + min) / 2;
            let h = 0, sat = 0;
            if (max !== min) {
              const d = max - min;
              sat = lig > 0.5 ? d / (2 - max - min) : d / (max + min);
              if (max === rn) h = ((gn - bn) / d + (gn < bn ? 6 : 0));
              else if (max === gn) h = ((bn - rn) / d + 2);
              else h = ((rn - gn) / d + 4);
              h *= 60;
            }
            const hh = Math.round(h), ss = Math.round(sat * 100), ll = Math.round(lig * 100);
            if (a < 1) return `hsla(${hh}, ${ss}%, ${ll}%, ${parseFloat(a.toFixed(3))})`;
            return `hsl(${hh}, ${ss}%, ${ll}%)`;
          }
          if (toUnit === 'cmyk') {
            const rn = r / 255, gn = g / 255, bn = b / 255;
            const k = 1 - Math.max(rn, gn, bn);
            if (k >= 1) return 'cmyk(0%, 0%, 0%, 100%)';
            const c = (1 - rn - k) / (1 - k);
            const mg = (1 - gn - k) / (1 - k);
            const y = (1 - bn - k) / (1 - k);
            return `cmyk(${Math.round(c * 100)}%, ${Math.round(mg * 100)}%, ${Math.round(y * 100)}%, ${Math.round(k * 100)}%)`;
          }
          return '';
        }
      }
    ]
  },
  {
    id: 'currency',
    name: 'Moeda',
    converters: [
      {
        id: 'moeda',
        name: 'Conversor de Moeda',
        description: 'Converta entre Real, Dólar, Euro e outras moedas com cotação atualizada.',
        isCurrency: true,
        units: [
          { id: 'BRL', name: 'Real Brasileiro' },
          { id: 'USD', name: 'Dólar Americano' },
          { id: 'EUR', name: 'Euro' },
          { id: 'GBP', name: 'Libra Esterlina' },
          { id: 'ARS', name: 'Peso Argentino' },
          { id: 'CLP', name: 'Peso Chileno' },
          { id: 'UYU', name: 'Peso Uruguaio' },
          { id: 'PYG', name: 'Guarani Paraguaio' },
          { id: 'JPY', name: 'Iene Japonês' },
          { id: 'CNY', name: 'Yuan Chinês' },
          { id: 'CAD', name: 'Dólar Canadense' },
          { id: 'AUD', name: 'Dólar Australiano' },
          { id: 'CHF', name: 'Franco Suíço' },
          { id: 'MXN', name: 'Peso Mexicano' },
          { id: 'INR', name: 'Rúpia Indiana' }
        ]
      }
    ]
  }
];